import styled from 'styled-components';

// import background from '../../assets/background.svg';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  position: relative;

  @media (min-width: 900px) {
    background-color: #f5f5f5;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Image = styled.img`
  height: 500px;

  @media (max-width: 760px) {
    height: 300px;
  }
`;

export const Message = styled.span`
  margin-top: 64px;
  margin-bottom: 128px;

  font-size: 18px;
  max-width: 800px;
  text-align: center;
  padding: 0 32px;

  @media (max-width: 760px) {
    margin-top: 32px;
  }

  @media (max-width: 560px) {
    margin-top: 0;
  }
`;
